import { useEffect } from "react"
import { navigate } from "aldoo-ra/Navigate"
import AquaMailFeaturesSection from "./Features/AquaMailFeaturesSection"
import useSitePlatform from "@components/Site/useSitePlatform"

// URL to group mapping (from FeatureController)
const URL_TO_GROUP = {
  "account-and-setup": "account_setup",
  "advanced-features": "advanced",
  "key-features": "key_features",
  "customizations": "customizations",
}

const platformMapping = {
  ios: "ios",
  android: "android", 
  windows: "android",
  linux: "android",
  mac: "ios",
  unknown: "android",
}

const getPlatformSafe = () => {
  if (typeof window === "undefined") {
    return "android"
  }
  
  const userAgent = window.navigator.userAgent.toLowerCase()

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return "ios"
  }
  if (/android/.test(userAgent)) {
    return "android"
  }
  if (/mac/.test(userAgent) && !/iphone|ipad|ipod/.test(userAgent)) {
    return "mac"
  }
  if (/win/.test(userAgent)) {
    return "windows"
  }
  if (/linux/.test(userAgent)) {
    return "linux"
  }
  return "unknown"
}

const FeaturesPage = () => {
  const [platform, setPlatform] = useSitePlatform()

  useEffect(() => {
    if (typeof window === "undefined") return
    
    const currentPath = window.location.pathname
    const pathParts = currentPath.split("/")
    
    // If this is just /features (not platform-specific), redirect to platform-specific
    if (pathParts.length === 2 && pathParts[1] === "features") {
      const detectedPlatform = getPlatformSafe()
      const sitePlatform = platformMapping[detectedPlatform] || "android"
      navigate(`/${sitePlatform}/features/account-and-setup`)
      return
    }
    
    // Extract platform from URL (e.g., /ios/features/account-and-setup)
    const urlPlatform = pathParts[1]
    if (urlPlatform && ["ios", "android", "windows"].includes(urlPlatform)) {
      setPlatform(urlPlatform)
    }
  }, [setPlatform])

  // Extract the group from the current URL
  const getCurrentGroup = () => {
    if (typeof window === "undefined") return "account_setup"
    
    const currentPath = window.location.pathname
    const urlSegment = currentPath.split("/").pop()
    return URL_TO_GROUP[urlSegment] || "account_setup"
  }

  const initialGroup = getCurrentGroup()

  return <AquaMailFeaturesSection group={initialGroup} />
}

export default FeaturesPage